<!--
Copyright (C) Cocouz Oy 2017 - All Rights Reserved 
-->
<template>
  <div class="sidebar__container" :class="{'stop-sidebar': stopSidebar }">
    <div class="sidebar__logo" :class="{'sidebar__show-logo': showLogo}">
      <!-- Brand -->
      <div  class="top-bar__brand">
        <div id="hamburger-icon" 
          href="#" 
          title="Menu" 
          :class="{'active': sidebarState }" 
          @click="openSidebar" 
        >
          <span class="line line-1"></span>
          <span class="line line-2"></span>
          <span class="line line-3"></span>
        </div>
        <a :href="lang + '/'"><img class="sidebar__mp-logo" :src="logoUrl" alt=""></a>
      </div>
    </div>
    <ul class="sidebar__items">
      <li class="sidebar__item">
        <a :href="lang + '/dashboard'"><img src="../assets/img/sidebar/ic_dashboard_black_24px.svg" /> {{ strings.dashboard }}</a>
      </li>
      <li class="sidebar__item">
        <a :href="lang + '/dashboard/inbox'"><img src="../assets/img/sidebar/ic_inbox_black_24px.svg" /> {{ strings.inbox }}</a>
      </li>
      <li class="sidebar__item">
        <a :href="lang + '/dashboard/venues'" v-if="!roleCustomer"><img src="../assets/img/sidebar/ic_business_black_24px.svg" /> {{ strings.venues }}</a>
      </li>
      <li class="sidebar__item">
        <a :href="lang + '/dashboard/statistics'" v-if="!roleCustomer"><img src="../assets/img/sidebar/ic_show_chart_black_24px.svg" /> {{ strings.statistics }}</a>
      </li>
      <li class="sidebar__item">
        <a :href="lang + '/dashboard/calendar'" v-if="!roleCustomer"><img src="../assets/img/sidebar/ic_date_range_black_24px.svg" /> {{ strings.calendar }}</a>
      </li>
      <li class="sidebar__item">
        <a :href="lang + '/dashboard/customers'" v-if="!roleCustomer"><img src="../assets/img/sidebar/ic_people_black_24px.svg" /> {{ strings.customers }}</a>
      </li>
      <li class="sidebar__item">
        <a :href="lang + '/dashboard/users'" v-if="displayForCustomer" ><img src="../assets/img/sidebar/ic_person_black_24px.svg" /> {{ strings.users }}</a>
      </li>
      <li class="sidebar__item">
        <a :href="lang + '/dashboard/products'" v-if="!roleCustomer"><img src="../assets/img/sidebar/ic_book_black_24px.svg" /> {{ strings.catalog }}</a>
      </li>
      <li class="sidebar__item">
        <a :href="lang + '/dashboard/booking-engine'" v-if="!roleCustomer"><img src="../assets/img/sidebar/ic_transform_black_24px.svg" /> {{ strings.engine }}</a>
      </li>
      <li class="sidebar__item">
        <a :href="lang + '/dashboard/cards'" v-if="displayForCustomer" ><img src="../assets/img/sidebar/ic_credit_card_black_24px.svg" /> {{ strings.billing }}</a>
      </li>
      <li class="sidebar__item">
        <a v-if="displayForCustomer"  href="https://blog.meetingpackage.com/faq?__hstc=105195228.263b478dee70ea2bab1453e367a7a299.1501482686220.1511266931562.1511273056243.250&__hssc=105195228.1.1511273056243&__hsfp=884007979"><img src="../assets/img/sidebar/ic_build_black_24px.svg" /> {{ strings.support }}</a>
      </li>
      <li class="sidebar__item" >
        <a :href="lang + '/user/logout'"><img src="../assets/img/sidebar/ic_power_settings_new_black_24px.svg" /> {{ strings.logout }}</a>
      </li>
      <MPCollider
        v-collision="['footer']" 
        @collide="onCollideHandler" 
        @collide-footer="onFooterCollide" 
      />
    </ul>
  </div>
</template>

<script>
  import MPCollider from './Collider.vue';

  let logoUrl = window.logoUrl;

  export default {
    data() {
      return {
        stopSidebar: false,
        roleCustomer: false
      }
    },
    components: {
      MPCollider
    },
    mounted() {
      if(this.$store.state.userRole == 'customer') {
        this.roleCustomer = true;
      }
    },
    computed: {
      strings () {
        return this.$store.state.strings;
      },
      displayForCustomer(){
        return !window.location.hostname.includes('cwteasymeetings.com');
      },
      lang() {
        let lang = this.$store.state.selectedLang;
        if(lang == 'en'){
          lang = '';
        } else {
          lang = '/' + lang;
        }
        return lang;
      },
      logoUrl () {
        return window.logoUrl
      },
      showLogo() {
        return this.$store.state.showLogo;
      },
      sidebarState () {
        return this.$store.state.sidebarState;
      },
    },
    methods: {
      openSidebar: function() {
        if (!(this.$store.state.sidebarState)) {
          this.$store.commit('setSidebar', true);
        } else {
          this.$store.commit('setSidebar', false);
        }
      },
      onFooterCollide (collider) {
        this.stopSidebar =  true;
      },
      onCollideHandler (collider) {
        this.stopSidebar = false;
      }
    }
  }
</script>